const carouselItems = [
  {
    title: '年度十大高分影片',
    desc: '精心评选本年度最具口碑与影响力的十部高分影片，涵盖动作、悬疑、纪录等多种类型，每一部都值得反复品味。',
    tag: '年度专题',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20awards%20atmosphere%20with%20warm%20golden%20spotlight%20on%20stage%2C%20elegant%20red%20carpet%20venue%2C%20professional%20film%20festival%20setting%2C%20rich%20warm%20amber%20lighting%2C%20premium%20cinema%20aesthetic%2C%20dramatic%20composition&width=800&height=450&seq=carousel-top10-01&orientation=landscape',
  },
  {
    title: '经典港片高清修复计划',
    desc: '我们已启动经典港片高清修复计划，首批20部经典作品已完成4K修复，让老片焕发新生，重温港片黄金年代的魅力。',
    tag: '修复计划',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20projector%20with%20warm%20film%20grain%20texture%2C%20retro%20movie%20theater%20atmosphere%2C%20golden%20light%20beam%20through%20dust%20particles%2C%20nostalgic%20cinematic%20aesthetic%2C%20rich%20sepia%20and%20amber%20tones&width=800&height=450&seq=carousel-restore-02&orientation=landscape',
  },
  {
    title: '纪录片精选周',
    desc: '每周精选5部高分纪录大片，涵盖自然、人文、科技等主题。打开眼界，从一部优质纪录片开始，高清呈现世界每一个角落的真实故事。',
    tag: '每周精选',
    image: 'https://readdy.ai/api/search-image?query=Professional%20documentary%20filmmaking%20scene%20with%20warm%20natural%20lighting%2C%20camera%20crew%20in%20golden%20hour%20landscape%2C%20cinematic%20production%20setup%2C%20rich%20earthy%20color%20palette%2C%20epic%20outdoor%20cinematography%20aesthetic&width=800&height=450&seq=carousel-docweek-03&orientation=landscape',
  },
  {
    title: '热门综艺爆笑名场面',
    desc: '收录各大热门综艺的精彩名场面合集，从搞笑段子到温情瞬间，一网打尽。忙碌一天后，来这里轻松一笑，释放所有压力。',
    tag: '综艺特辑',
    image: 'https://readdy.ai/api/search-image?query=Bright%20and%20vibrant%20variety%20show%20stage%20set%20with%20colorful%20warm%20lighting%20design%2C%20entertainment%20studio%20production%2C%20cheerful%20and%20energetic%20atmosphere%2C%20professional%20broadcast%20quality%2C%20golden%20and%20amber%20stage%20lights&width=800&height=450&seq=carousel-variety-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            焦点专题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            本周焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            不可错过的精选内容专题合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="rounded-xl overflow-hidden border border-background-200/60 bg-background-100 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="relative w-full h-52 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-label font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}